/** Rutas locales alineadas con BNT.TaxRepository/XML_Descargados (sat_tax_repository.py). */

export const TAX_REPO_ROOT_FOLDER = "BNT.TaxRepository";
export const TAX_REPO_XML_SUBFOLDER = "XML_Descargados";

const LS_TAX_REPO_ROOT_LABEL = "visor:tax_repo_root_label";
const LS_TAX_REPO_ROOT_READY = "visor:tax_repo_root_ready";

const MESES = {
  1: "Enero",
  2: "Febrero",
  3: "Marzo",
  4: "Abril",
  5: "Mayo",
  6: "Junio",
  7: "Julio",
  8: "Agosto",
  9: "Septiembre",
  10: "Octubre",
  11: "Noviembre",
  12: "Diciembre",
};

export function getStoredTaxRepoRootLabel() {
  try {
    return localStorage.getItem(LS_TAX_REPO_ROOT_LABEL) || "";
  } catch {
    return "";
  }
}

export function setStoredTaxRepoRootLabel(label) {
  try {
    if (label) localStorage.setItem(LS_TAX_REPO_ROOT_LABEL, label);
    else localStorage.removeItem(LS_TAX_REPO_ROOT_LABEL);
  } catch {
    /* ignore */
  }
}

export function isStoredTaxRepoRootReady() {
  try {
    return localStorage.getItem(LS_TAX_REPO_ROOT_READY) === "1";
  } catch {
    return false;
  }
}

export function setStoredTaxRepoRootReady(ready) {
  try {
    if (ready) localStorage.setItem(LS_TAX_REPO_ROOT_READY, "1");
    else localStorage.removeItem(LS_TAX_REPO_ROOT_READY);
  } catch {
    /* ignore */
  }
}

export function clearStoredTaxRepoRootPrefs() {
  setStoredTaxRepoRootLabel("");
  setStoredTaxRepoRootReady(false);
}

export function monthFolderName(month) {
  const m = Number(month);
  if (!MESES[m]) return `${String(m).padStart(2, "0")}_Mes`;
  return `${String(m).padStart(2, "0")}_${MESES[m]}`;
}

function direccionFolderFromItem(item) {
  const d = String(item?.direccion || "").trim().toLowerCase();
  if (d === "recibido") return "Recibidos";
  if (d === "emitido") return "Emitidos";
  const rel = String(item?.relative_xml || "");
  if (rel.includes("/Recibidos/")) return "Recibidos";
  return "Emitidos";
}

function yearMonthFromItem(item) {
  const fecha = String(item?.fecha || "").slice(0, 10);
  const parts = fecha.split("-");
  if (parts.length >= 2) {
    const year = parts[0];
    const month = parts[1];
    if (year && month) return { year, month: Number(month) };
  }
  const rel = String(item?.relative_xml || "");
  const m = rel.match(/\/(\d{4})\/(\d{2})\//);
  if (m) return { year: m[1], month: Number(m[2]) };
  const now = new Date();
  return { year: String(now.getFullYear()), month: now.getMonth() + 1 };
}

function fileNameFromItem(item) {
  const rel = String(item?.relative_xml || "").replace(/\\/g, "/");
  const base = rel.split("/").filter(Boolean).pop();
  if (base) return base;
  const uuid = String(item?.uuid || "sin-uuid").toUpperCase();
  return `${uuid}.xml`;
}

function estadoFolderFromItem(item) {
  const e = String(item?.estado || "").trim().toLowerCase();
  if (e === "cancelado" || e === "cancelada") return "Cancelados";
  return "Vigentes";
}

/**
 * Ruta relativa a la carpeta raíz elegida por el usuario:
 * BNT.TaxRepository / RFC / XML_Descargados / AÑO / Emitidos|Recibidos / 03_Marzo / Vigentes|Cancelados / archivo.xml
 */
export function mapManifestItemToTaxRepositoryPath(item, clientRfc) {
  const rfc = (clientRfc || "SIN_RFC").trim().toUpperCase();
  const dir = direccionFolderFromItem(item);
  const { year, month } = yearMonthFromItem(item);
  const monthFolder = monthFolderName(month);
  const estatus = estadoFolderFromItem(item);
  const fileName = fileNameFromItem(item);
  return `${TAX_REPO_ROOT_FOLDER}/${rfc}/${TAX_REPO_XML_SUBFOLDER}/${year}/${dir}/${monthFolder}/${estatus}/${fileName}`;
}

export function localPdfPathForTaxRepositoryXmlPath(xmlRelativePath) {
  return String(xmlRelativePath || "").replace(/\.xml$/i, ".pdf");
}

/** Ejemplo legible para la UI. */
export function taxRepositoryPathHint() {
  return `${TAX_REPO_ROOT_FOLDER} / RFC / ${TAX_REPO_XML_SUBFOLDER} / AÑO / Emitidos|Recibidos / 03_Marzo / Vigentes|Cancelados / UUID.xml`;
}
